import { useCallback } from 'react';
import * as XLSX from 'xlsx';

const useTemplateDownload = () => {
  const generateExcelTemplate = useCallback((headers, filename = 'template') => {
    try {
      // Create a new workbook
      const wb = XLSX.utils.book_new();
      
      // Create worksheet with headers
      const ws = XLSX.utils.aoa_to_sheet([headers]);
      
      // Add some styling/formatting
      const range = XLSX.utils.decode_range(ws['!ref']);
      
      // Set column widths
      const colWidths = headers.map(() => ({ wch: 25 }));
      ws['!cols'] = colWidths;
      
      // Add the worksheet to workbook
      XLSX.utils.book_append_sheet(wb, ws, 'Template');
      
      // Generate Excel file and trigger download
      XLSX.writeFile(wb, `${filename}.xlsx`);
      
      return {
        success: true,
        message: 'Template downloaded successfully'
      };
    } catch (error) {
      console.error('Error generating template:', error);
      return {
        success: false,
        message: 'Failed to generate template'
      };
    }
  }, []);

  const generateCSVTemplate = useCallback((headers, filename = 'template') => {
    try {
      const csvContent = headers.join(',');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      
      // Create download link
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `${filename}.csv`);
      link.style.visibility = 'hidden';
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Clean up
      URL.revokeObjectURL(url);
      
      return {
        success: true,
        message: 'Template downloaded successfully'
      };
    } catch (error) {
      console.error('Error generating CSV template:', error);
      return {
        success: false,
        message: 'Failed to generate template'
      };
    }
  }, []);

  const downloadTemplate = useCallback((headers, format = 'excel', filename = 'template') => {
    if (format === 'csv') {
      return generateCSVTemplate(headers, filename);
    } else {
      return generateExcelTemplate(headers, filename);
    }
  }, [generateExcelTemplate, generateCSVTemplate]);

  return {
    downloadTemplate,
    generateExcelTemplate,
    generateCSVTemplate
  };
};

export default useTemplateDownload; 